import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { GeneralSettingsComponent } from './general-settings/general-settings.component';
import { CollaboratorsSettingsComponent } from './collaborators-settings/collaborators-settings.component';
import { VersionHistorySettingsComponent } from './version-history-settings/version-history-settings.component';
import { TaxonomyService } from '../../../services/taxonomy.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-taxonomy-settings',
  standalone: true,
  imports: [
    MatTabsModule,
    CommonModule,
    MatIconModule,
    GeneralSettingsComponent,
    CollaboratorsSettingsComponent,
    VersionHistorySettingsComponent,
  ],
  templateUrl: './taxonomy-settings.component.html',
  styleUrl: './taxonomy-settings.component.scss',
})
export class TaxonomySettingsComponent {
  selectedTabIndex = 0;

  constructor(
    private taxonomyService: TaxonomyService,
    private router: Router,
    public notificationService: NotificationService
  ) {}

  ngOnInit() {}

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
  }

  taxonomyId = JSON.parse(sessionStorage.getItem('selectedTaxonomy') || '{}').taxonomy_id || '';

  onCrossClick() {
    this.router.navigate(['/taxonomy-dashboard', this.taxonomyId]);
  }
}
function computed(arg0: () => string) {
  throw new Error('Function not implemented.');
}
